import SectionHeading from "./SectionHeading";

export default function MissionStatement() {
  return (
    <SectionHeading
      highlightText="Ваш электронный кошелёк для международных платежей,"
      maxWidth="1080px"
      hasResponsiveBreak
    >
      переводов с низкими комиссиями и безопасными картами. Наслаждайтесь финансовой свободой с удобным приложением и поддержкой Apple/ Google Pay.
    </SectionHeading>
  );
}
